export default {"src":"/_next/static/media/c2c-coverage.2c122a93.svg","height":318,"width":331,"blurWidth":0,"blurHeight":0};